import React, { Component} from 'react';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import Delete from '../images/deleteRecord.png';

class ServiceCallForm extends Component {
	render() {
		return (
			<Col xs={this.props.colsize}>
				<Row>
					<Col xs={12}>
						<h4 className="ml-0 mt-0 mb-3">{this.props.title}
							<Button className="clearBtn miniBtnDelete headerIcon" onClick={this.props.deleteSingleRecord}>
								<img src={Delete} className="deleteIcon"/>
							</Button>
						</h4>
					</Col>
					<Col xs={8}>
						<Row>{this.props.section1}</Row>
					</Col>
					<Col xs={4}>
						<Row>{this.props.section2}</Row>
					</Col>
				</Row>
			</Col>
		);
	}
}

export default ServiceCallForm;






// WEBPACK FOOTER //
// ./src/components/ServiceCallForm.js